import React from 'react';
import StreamingCardPlaceholder from './StreamingCardPlaceholder';
import { prepareHtmlDraft } from '@/lib/htmlDraftPreview.web';
import useStreamingHtmlDraft from '@/hooks/useStreamingHtmlDraft';

export default function StreamingHtmlPreview({ html, colors, fontScale = 1 }) {
  const draft = useStreamingHtmlDraft(html, prepareHtmlDraft);
  if (!draft) return <StreamingCardPlaceholder kind="html" colors={colors} fontScale={fontScale} />;
  return <div data-streaming-card="html" data-copy-exclude="" aria-busy="true"
    style={{ margin: '8px 0', border: `1px solid ${colors.border_color_secondary}`, borderRadius: 16, overflow: 'hidden' }}>
    <div role="status" style={{ padding: '10px 14px', color: colors.text_color_secondary, fontSize: 13 * fontScale }}>
      Building preview… Controls will work when it’s ready.
    </div>
    <iframe title="Design in progress" sandbox="" referrerPolicy="no-referrer" srcDoc={draft}
      tabIndex={-1} aria-hidden="true"
      style={{ display: 'block', width: '100%', height: 360, border: 0, pointerEvents: 'none', background: '#fff' }} />
  </div>;
}
